import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import CoffeeIcon from '@mui/icons-material/Coffee';
import { useThreadsAuth } from "../../hooks/useThreadsAuth";

const CafeLoginPromptModal = ({ open, onClose, isMobile }) => {
  const { login: threadsLogin } = useThreadsAuth();
  const handleLoginClick = () => {
    // Save return flags to sessionStorage
    sessionStorage.setItem('cafe_registration_return', 'true');
    sessionStorage.setItem('magazine_issue_id', '2025-09');

    // Determine redirect path based on current location
    const currentPath = window.location.pathname;
    const redirectPath = currentPath.startsWith('/threads-cafe-map')
      ? '/threads-cafe-map'
      : '/monthly-threads/2025-09';

    // Redirect back to current page context after login
    threadsLogin(redirectPath);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <CoffeeIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
        <Typography variant="h6" component="div">
          카페 등록하기
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', mb: 2 }}>
          카페를 등록하려면 Threads 로그인이 필요합니다.
        </DialogContentText>

        <Box sx={{
          bgcolor: 'grey.50',
          p: 2,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'grey.300'
        }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            로그인 후 혜택:
          </Typography>
          <Typography variant="body2" component="ul" sx={{ m: 0, pl: 2 }}>
            <li>내 카페를 매거진 지도에 등록</li>
            <li>카페 소개글 작성 및 수정</li>
            <li>다른 사용자들과 카페 정보 공유</li>
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
          size="large"
        >
          취소
        </Button>
        <Button
          onClick={handleLoginClick}
          variant="contained"
          color="primary"
          size="large"
          startIcon={<LoginIcon />}
          sx={{ minWidth: 150 }}
        >
          Threads로 로그인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CafeLoginPromptModal;